
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/reds-202203",
      function () {
        return require("private-next-pages/campaign/reds-202203/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/reds-202203"])
      });
    }
  